// 电话接听时候的信息展示
import { computed, reactive } from 'vue'
import { roleMap } from './config'
import { useStore } from 'vuex'
import {
  aiOutboundTransfer,
  getCallIntent,
  getLastService,
  getLatestThreeService,
  transferCallSwitch
} from '@/api/login'

const useServiceInfo = () => {
  const store = useStore()
  const userInfo = computed(() => store.state.tccc.tcccUserInfo)
  const data = reactive({
    intentType: '',
    intentTitle: '',
    lastServeText: '',
    showTransfer: false,
    latestList: [],
    AiOutbound: {
      scene: 0,
      sceneStr: ''
    }
  })
  // 上次服务信息
  const getLast = () => {
    data.lastServeText = ''
    if (!userInfo.value?.userId) return
    const params = {
      patientId: userInfo.value.userId
    }
    getLastService(params).then(result => {
      if (result?.calleeType) {
        const text1 = `${roleMap[result.calleeType]}-${result.calleeName}`
        const text2 = `${result.startTime}`
        data.lastServeText = text1 + '  ' + text2
      } else {
        data.lastServeText = ''
      }
    })
  }
  // 呼入标记
  const getIntent = () => {
    data.intentType = ''
    data.intentTitle = ''
    if (!userInfo.value?.options?.sessionId) return
    const param = {
      tcccSessionId: userInfo.value.options.sessionId
    }
    getCallIntent(param).then(result => {
      // console.log('getCallIntent', result)
      if (result?.intentType) {
        data.intentType = result.intentType
        data.intentTitle = result.intentTitle
      } else {
        const ivrPaths = userInfo.value.options.ivrPath
        const lastIVR = ivrPaths[ivrPaths.length - 1] || {}
        data.intentType = lastIVR.key
        // ①②③④⑤
        const arr = ['拨号诉求', '拨号诉求①：服务咨询', '拨号诉求②：投诉建议']
        data.intentTitle = arr[data.intentType] || '拨号诉求'
      }
    })
  }
  // 呼入时候，获取转交状态是否展示
  const getTransferCallSwitch = () => {
    data.showTransfer = false
    transferCallSwitch().then(result => {
      // console.log('transferCallSwitch', result)
      data.showTransfer = result
    })
  }
  // 呼入时候，获取最近3次
  const getLatestService = () => {
    const params = {
      patientId: userInfo.value.userId
    }
    data.latestList = []
    getLatestThreeService(params).then(result => {
      data.latestList = result
    })
  }
  // 呼入时候，根据 sessionId 判断是否为 AI 转人工
  const getAiOutboundTransfer = () => {
    data.AiOutbound = {}
    if (!userInfo.value?.options?.sessionId) return
    const params = {
      sessionId: userInfo.value.options.sessionId
    }
    console.log(`output->getTransferInfo`)
    aiOutboundTransfer(params).then(res => {
      data.AiOutbound = res
    })
  }

  const getTransferInfo = () => {
    getLast()
    getIntent()
    getTransferCallSwitch()
    getLatestService()
    getAiOutboundTransfer()
  }
  return { getTransferInfo, data }
}
export { useServiceInfo }
